import { requestInFlatStatuses } from './common';
import { requestFlat, requestFlatPeriod } from './requestFlat';

export const addressStagesColorsMap = new Map([
  [4, '#32d74c'], // управление
  [3, '#3ba3e2'], // приемка
  [2, '#62d3fd'], // внутренняя приемка
  [1, '#fba500'], // строительство
]);

export const acceptanceStatusesColorsMap = new Map([
  [4, '#32d74c'], // Односторонняя передача
  [3, '#3ba3e2'], // Принято
  [2, '#62d3fd'], // Принято с замечаниями
  [1, '#fba500'], // Не принято
]);

export const requestInFlatStagesColorsMap = new Map([
  [requestInFlatStatuses.immediate, '#e41c1c'],
  [requestInFlatStatuses.debt, '#ff9500'],
  [requestInFlatStatuses.active, '#5361f3'],
  [requestInFlatStatuses.comment, '#dc429f'],
]);

export const houseStagesColorsMap = new Map([
  [1, '#aeadb2'], // строительство
  [6, '#ff9500'], // приемка
  [7, '#32d74c'], // сдан
]);

export const flatRequestColorsMap = new Map([
  [requestFlat.NEW_REQUEST, '#fba500'], // новая
  [requestFlat.WORK_REQUEST, '#62d3fd'], // в работе
  [requestFlat.COMPLETED_REQUEST, '#3ba3e2'], // выполнена
  [requestFlat.CLOSE_REQUEST, '#32d74c'], // закрыта
]);

export const requestInPeriodColorMap = new Map([
  [requestFlatPeriod.rightTime, '#0995ed'], // срок подходит
  [requestFlatPeriod.expired, '#e41c1c'], // просрочены
  [requestFlatPeriod.excess, '#7b0048'], // превышение провеочной даты
  [requestFlatPeriod.finishingTouches, '#8ad58b'], // чистовая отделка
]);

export const acceptanceStatusesBorderColorsMap = new Map([
  [4, '#067408'], // Односторонняя передача
  [3, '#c72579'], // Принято
  [2, '#ad62fd'], // Принято с замечаниями
  [1, '#ff5e29'], // Не принято
]);

export const constructionBorderColorMap = new Map([
  [1, '#ad62fd'], // идут работы
  [2, '#067408'], // работы завершены
]);

export const internalAcceptanceBorderColorMap = new Map([
  [3, '#ad62fd'], // не готова к передаче
  [4, '#067408'], // готова к передаче
]);
